module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.0","quantity":0},{"color":"#9dc4b5","label":" 0.0- 0.19363","quantity":0.00194},{"color":"#e6efc3","label":" 0.19363- 0.57724","quantity":0.00577},{"color":"#ffe89e","label":" 0.57724- 1.13939","quantity":0.01139},{"color":"#f5af7f","label":" 1.13939- 2.14337","quantity":0.02143},{"color":"#ed6d32","label":" 2.14337- 9.45832","quantity":0.09458}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_70.json
// module id = UwqJ
// module chunks = 171